__turbopack_context__.v({
  "column": "_IcuLa_column",
  "wrapper": "_IcuLa_wrapper",
});
